// ** React Imports
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

// ** Redux & Store & Actions
import { useSelector, useDispatch } from "react-redux";
import { getSingleNewsJson } from "store/modules/service-pages/news.slice";

// ** Third Party Components
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import md5 from "md5";

// ** Custom Components
import Heading from "components/typography/Heading";
import Paragraph from "components/typography/Paragraph";
import Block from "components/layout/Block";
import LinkNative from "components/layout/LinkNative";
import Text from "components/typography/Text";
import ScrollToTop from "components/global/ScrollToTop";
import GoBackLink from "components/layout/GoBackLink";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";

// ** Utils & Helpers
import convertText from "utils/convertText";
import DateTime from "utils/datetime";
import { SITE_NAME } from "helpers/constants";

// #####################################################

const Article = ({
	match: {
		params: { id },
	},
	history: { goBack },
}) => {
	const dispatch = useDispatch();
	const { t } = useTranslation(["pages"]);
	const language = useSelector((state) => state.globalCommon.language);
	const history = useHistory();
	const location = useLocation();

	// ** Dane strony: 'Single News'
	const singleNewsData = useSelector(
		(state) => state.servicePageNews.singleNews.data
	);
	const md5HashFromState = useSelector(
		(state) => state.servicePageNews.singleNews.hash
	);

	const {
		id: articleId,
		name,
		date,
		description_formated,
	} = singleNewsData || {};

	useEffect(() => {
		const actualMd5Hash = md5(JSON.stringify({ language, id }));

		if (actualMd5Hash !== md5HashFromState) {
			dispatch(
				getSingleNewsJson({
					newsId: id,
					language,
				})
			).then((data) => {
				if (data?.result?.status === 204) history.push("/error404");
			});
		}
	}, [language, id]);

	const articleTitle =
		name || location?.state?.articleTitle
			? `${name || location?.state?.articleTitle}`
			: t("pages:news");

	// #####################################################

	return (
		<>
			<Helmet title={articleTitle} titleTemplate={`%s - ${SITE_NAME}`}>
				<meta
					property="og:title"
					content={
						name?.length > 60
							? `${name?.substring(0, 60)}...`
							: name
					}
				/>
			</Helmet>
			<ScrollToTop />
			<CardWrapper>
				<CardBody>
					<Block flex column withRowGap={"1.5rem"}>
						<Block flex column>
							<Heading
								type="h3"
								data-testid="single-news-heading"
							>
								{name}
							</Heading>

							<Text color="grey" small>
								{t("common:added")}:{" "}
								<time>{new DateTime(date).format()}</time>
							</Text>
						</Block>

						<Paragraph textBreak mb={0}>
							{convertText({
								pieces: [description_formated],
							})}
						</Paragraph>
						{articleId === 223 && language === "pl" && (
							<Block>
								<LinkNative
									href={`https://imgcdn.datezone.com/static/img/layout/paymentua.png?v=2`}
									target="_blank"
								>
									<img
										style={{
											width: "200px",
											margin: ".5rem 0",
										}}
										src="https://imgcdn.datezone.com/static/img/layout/paymentua.png?v=2"
									/>
								</LinkNative>
							</Block>
						)}

						<Block>
							<GoBackLink to="/news" goBackFunction={goBack} />
						</Block>
					</Block>
				</CardBody>
			</CardWrapper>
		</>
	);
};

// #####################################################

export default Article;

// #####################################################
